import {fork} from 'redux-saga/effects'
import {createSaga} from './create'
import {deleteSaga} from './delete'

export function* roleSaga() {
  yield fork(createSaga)
  yield fork(deleteSaga)
}
